import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const CARD_TITLE_FONT_SIZE = "15px";
const RESOURCE_LINK_FONT_SIZE = "13.5px";

export const useRetrospectivePageStyles = makeStyles({
  root: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    padding: "0px 32px",
  },

  content: {
    maxWidth: "1120px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  intro: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink2,
    lineHeight: String(designTokens.lineHeight.relaxed),
  },
  questionsSection: {
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
    overflow: "hidden",
  },
  questionsSectionHeaderButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[5]}`,
    backgroundColor: projectIqTokens.card,
    border: "none",
    cursor: "pointer",
    textAlign: "start",
    fontFamily: projectIqTokens.fontFamily,
    ":hover": {
      backgroundColor: projectIqTokens.bg,
    },
  },
  questionsSectionChevron: {
    color: projectIqTokens.faint,
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    transition: `transform ${designTokens.transition.fast}`,
  },
  questionsSectionChevronExpanded: {
    transform: "rotate(90deg)",
  },
  questionsSectionTitle: {
    fontSize: CARD_TITLE_FONT_SIZE,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
    flex: 1,
  },
  questionsSectionBody: {
    borderTop: `1px solid ${projectIqTokens.line}`,
    padding: designTokens.spacing[5],
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[5],
  },
  cardRow: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: designTokens.spacing[5],
  },
  card: {
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[5]}`,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
  },
  cardIcon: {
    width: "32px",
    height: "32px",
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: projectIqTokens.tealSoft,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: projectIqTokens.teal,
    flexShrink: 0,
  },
  cardTitle: {
    fontSize: CARD_TITLE_FONT_SIZE,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
    margin: 0,
  },
  cardBody: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink2,
    lineHeight: String(designTokens.lineHeight.relaxed),
  },
  cardList: {
    margin: 0,
    paddingLeft: designTokens.spacing[5],
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  cardListItem: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink2,
    lineHeight: String(designTokens.lineHeight.normal),
  },
  resourcesRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[5]}`,
    backgroundColor: projectIqTokens.tealSoft,
    border: `1px solid ${projectIqTokens.tealLine}`,
    borderRadius: designTokens.borderRadius.lg,
  },
  resourcesLabel: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.tealInk,
  },
  resourceLink: {
    fontSize: RESOURCE_LINK_FONT_SIZE,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.teal,
    textDecoration: "none",
    ":hover": {
      textDecoration: "underline",
      color: projectIqTokens.tealInk,
    },
  },
  resourceDivider: {
    color: projectIqTokens.tealLine,
    userSelect: "none",
  },
  caseStudyWrapper: {
    display: "flex",
    flexDirection: "column",
    marginTop: designTokens.spacing[6],
  },
});
